import "./ProgressSpinner.scss";

const ProgressSpinner = () => {
  return (
    <div>
      <span className="proProgressRoot">
        <svg className="proProgressSvg" viewBox="22 22 44 44">
          <circle
            className="proProgressCircle"
            cx="44"
            cy="44"
            r="20.2"
            fill="none"
            strokeWidth="3.6"
          ></circle>
        </svg>
      </span>
    </div>
  );
};

export default ProgressSpinner;
